import React from 'react';
import PropTypes from 'prop-types';

// Onboarding status strings returned by the invitation APIs. Regular users get
// the same three values on the per-invitation listing; super-admin drill-downs
// use them in the referrals modal.
export const INVITATION_STATUS_PENDING = 'Pending Approval';
export const INVITATION_STATUS_APPROVED = 'Approved';
export const INVITATION_STATUS_NOT_SIGNED_UP = "Didn't Sign Up";

export const getInvitationStatusClassName = (status) => {
    if (status === INVITATION_STATUS_APPROVED) return 'activeStatus userRequestStatusApproved';
    if (status === INVITATION_STATUS_PENDING) return 'activeStatus userRequestStatusUnderReview';
    return 'activeStatus userRequestStatusDraft';
};

// Inline badge without a button wrapper so it doesn't inherit button layout / clipping.
export const InvitationStatusPill = ({ status }) => (
    <span
        className={getInvitationStatusClassName(status)}
        style={{ display: 'inline-block', whiteSpace: 'nowrap' }}
    >
        {status}
    </span>
);

InvitationStatusPill.propTypes = {
    status: PropTypes.string,
};

export default InvitationStatusPill;
